import { render, staticRenderFns } from "./PepSideBar.vue?vue&type=template&id=2183399e&"
import script from "./PepSideBar.vue?vue&type=script&lang=js&"
export * from "./PepSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports